exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



// WEBPACK FOOTER //
// webpack:///node_modules/deep-equal/lib/keys.js